var map = {
	"./AMERICAS_Mexico_Tuxpan_Aerial_Tanks_2021-06_1920x550.jpg": 41032,
	"./Oficina Argentina_BsAs.jpeg": 98092,
	"./Oficina Brasil_RJ.jpeg": 281,
	"./Oficina Mexico.jpeg": 12446,
	"./Oficina Peru.jpeg": 97171,
	"./Oiltanking_South-America_Argentina_Brandsen_Building-Outside_2010-01-15_014.jpg": 26308,
	"./Oiltanking_South-America_Argentina_Puerto-Rosales_Building-Outside_2012-01-24_6584.jpg": 46346,
	"./Oiltanking_South-America_Brazil_Vitoria_Truckloading_2012-06-29_0942.jpg": 8333,
	"./Oiltanking_South-America_Colombia_Cartagena_Terminal-Aerial_2001-06-10.80016292.jpg": 15039,
	"./Oiltanking_South-America_Peru_Callao.jpg": 69896,
	"./Oiltanking_South-America_Peru_Chimbote_Tank_2016-10-13_1.jpg": 2149,
	"./Oiltanking_South-America_Port-Acu.jpg": 66342,
	"./Terminal Page Puerto Bahia.jpg": 62874,
	"./image_ot-panama-coassa-colon_tanks1_1920px.jpg": 86266,
	"./image_ot-peru-andina-services_marine-platform1_1920px.jpg": 37259,
	"./image_ot-peru-eten_tanks_1920px.jpg": 275,
	"./image_ot-peru-matarani_tanks1_1920px.jpg": 37019,
	"./image_ot-peru-salaverry_tanks2_1920px.jpg": 86932,
	"./image_ot-peru-supe_tanks_1920px.jpg": 66458
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 38697;